import React, { useState } from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import errorBoundary from '@ifeng-fe/errorBoundary';
import FormTitle from '@src/mobile/phtvHostHK2024/layout/Component/FormTitle';
import FormInput from '@src/mobile/phtvHostHK2024/layout/Component/FormInput';
import FormTextarea from '@src/mobile/phtvHostHK2024/layout/Component/FormTextarea';
import FormWaring from '@src/mobile/phtvHostHK2024/layout/Component/FormWaring';
import { zhanden } from '@src/utils/zhanden'; 

const Needlessly = ({
    formData,
    setFormDataHandle,
    warningTextList,
    updateSuccess,
    languages
}) => {
    const [isUnfold, setUnfold] = useState(true);

    const changeInputHandle = (key, value) => {
        setFormDataHandle(key, value);
    };

    return (
        <div className={styles.needlessly}>
            <div className={styles.needlesslyHead}>
                <div className={styles.needlesslyTitle}>{zhanden[languages].optionalInfo.title}</div>
            </div>
            <div style={{ display: isUnfold ? 'block' : 'none' }} className={styles.formNeedlesslyList}>
                <div className={styles.formListBox}>
                    {/* 介绍一下自己 */}
                    <FormTitle
                        title={zhanden[languages].introduce.title}
                        name="self_introduction"
                        warningText={warningTextList['self_introduction']}
                    />
                    <FormTextarea
                        limitWord={1000}
                        formData={formData}
                        name="self_introduction"
                        changeInputHandle={changeInputHandle}
                        updateSuccess={updateSuccess}
                    />
                    <FormWaring warningText={warningTextList['self_introduction']} />
                    {/* 现职 */}
                    <FormTitle name="current_occupation" title={zhanden[languages].occupation.title} warningText={warningTextList['current_occupation']} />
                    <FormTextarea
                        limitWord={100}
                        formData={formData}
                        placeholder={zhanden[languages].occupation.placeholder}
                        name="current_occupation"
                        changeInputHandle={changeInputHandle}
                        updateSuccess={updateSuccess}
                    />
                    <FormWaring warningText={warningTextList['current_occupation']} />
                    {/* 所在城市 */}
                    <FormTitle name="current_city" title={zhanden[languages].city.title} warningText={warningTextList['current_city']} />
                    <FormInput name="current_city" formData={formData} placeholder="" changeInputHandle={changeInputHandle} />
                    <FormWaring warningText={warningTextList['current_city']} />
                    {/* 社交网络联系方式 */}
                    <FormTitle
                        title={zhanden[languages].about.title}
                        name="other_platforms"
                        warningText={warningTextList['other_platforms']}
                    />
                    <FormTextarea
                        limitWord={300}
                        formData={formData}
                        placeholder={zhanden[languages].about.placeholder}
                        name="other_platforms"
                        changeInputHandle={changeInputHandle}
                        updateSuccess={updateSuccess}
                    />
                    <FormWaring warningText={warningTextList['other_platforms']} />
                </div>
            </div>
        </div>
    );
};

Needlessly.propTypes = {
    formData: PropTypes.object,
    setFormDataHandle: PropTypes.func,
    warningTextList: PropTypes.object,
    updateSuccess: PropTypes.bool,
    languages: PropTypes.string
};

export default errorBoundary(Needlessly);
